import { Component, Input, OnDestroy, OnInit } from "@angular/core";

@Component({
    selector: "app-graph-loader",
    templateUrl: "./graph-loader.component.html",
    styleUrls: ["./graph-loader.component.scss"],
})
export class GraphLoaderComponent implements OnInit, OnDestroy {
    constructor() {}
    @Input() parentPage = "";
    messages = ["Fetching data, please wait...", "Almost there...", "Just a moment...", "Loading latest updates...", "Hold tight! Retrieving info..."];
    showMessage = "";
    index = 0;
    id: any;
    ngOnInit(): void {
        this.changeMessage();
        this.id = setInterval(() => {
            this.changeMessage();
        }, 5000);
    }
    ngOnDestroy() {
        if (this.id) {
            clearInterval(this.id);
        }
    }
    changeMessage() {
        this.index = (this.index + 1) % this.messages.length;
        this.showMessage = this.messages[this.index];
    }
}
